import React from 'react'
import PackingBomList from '../components/PackingBomList'

const PackingBom = () => {
	return <PackingBomList />
}

export default PackingBom
